export default "__VITE_ASSET___r5qJQs1__"